module.exports = __webpack_public_path__ + "img/LOP.1a3d8727.svg";